import { HttpInjector } from '@/cowboy/http/HttpInjector'
import { RecipientResponse } from '@/cowboy/wallet/object/RecipientResponse'

export class WalletApi extends HttpInjector {
  /**
   * TODO what does response look like?
   * TODO what is the URL for this?
   * Unknown usage
   * @return {Promise<unknown>}
   */
  static async walletEmails () {
    const response = await this.$http.get('WALLET_EMAILS_URL?')
    return response.data
    // return this.cast(response.data, <OBJECT TO RETURN>)
  }

  /**
   * Complete Signup
   * @param {string} rewardsEmail
   * @return {Promise<void>}
   */
  static async completeSignup (rewardsEmail) {
    await this.$http.post('/recipient/complete-signup', { rewardsEmail })
  }

  /**
   * Fetches the recipient Details
   * @return {Promise<RecipientResponse>}
   */
  static async getRecipientDetails () {
    const response = await this.$http.get('/recipient/details')
    return this.cast(response.data, RecipientResponse)
  }

  /**
   * Register recipient with credentials
   * @param {LoginRequest} credentials
   * @return {Promise<void>}
   */
  static async registerRecipient (credentials) {
    await this.$http.post('/recipient/create', credentials)
  }

  /**
   * Deletes the recipients wallet
   * @return {Promise<void>}
   */
  static async deleteRecipientWallet () {
    await this.$http.delete('/recipient')
  }

  /**
   * Recipient forgot password
   * @param {string} emailAddress
   * @return {Promise<void>}
   */
  static async forgotPassword (emailAddress) {
    return await this.$http.post('/recipient/forgot-password', { emailAddress })
  }

  /**
   * converts forgot password token to jwt token request
   * @param {string} token
   * @return {Promise<void>}
   */
  static async forgotPasswordTokenToJwt (token) {
    return await this.$http.post('/recipient/forgot-password-jwt', { token })
  }

  /**
   * Resend recipient verification email
   * @param {string} emailAddress
   * @return {Promise<void>}
   */
  static async resendVerificationEmail (emailAddress) {
    return await this.$http.post('/recipient/resend-verification-email', { emailAddress })
  }

  /**
   * Reset user password request
   * @param {string} password
   * @param {string} confirmPassword
   * @return {Promise<void>}
   */
  static async resetPassword (password, confirmPassword) {
    return await this.$http.post('/recipient/reset-password', { password, verifiedPassword: confirmPassword })
  }

  /**
   * Refresh auth token
   * @return {Promise<void>}
   */
  static async tokenRefresh () {
    return await this.$http.post('/token/refresh')
  }

  /**
   * Login to wallet using user credentials
   * @param {string} emailAddress
   * @param {string} password
   * @return {Promise<void>}
   */
  static async login (emailAddress, password) {
    return await this.$http.post('/recipient/login', { emailAddress, password })
  }
}
